import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const problems = ['Tardás horas buscando material para cada clase', 'No encontrás contenido adaptado al LSA argentino real', 'Tus alumnos avanzan lento porque el material no tiene progresión clara', 'Armás todo desde cero cada vez que empieza un nuevo alumno', 'No tenés un diccionario visual completo para consultar en clase', 'Te cansás de producir contenido y te queda menos energía para enseñar'];
  return <section className="bg-lsa-light text-lsa-dark py-12 px-5" data-id="element-222">
      <div className="max-w-xl mx-auto" data-id="element-223">
        <h2 className="text-[28px] font-bold mb-4 leading-tight text-center" data-id="element-224">
          ¿Cuántas horas más vas a perder armando clases desde cero?
        </h2>

        <p className="text-center text-[16px] mb-8 text-lsa-dark/80 font-medium" data-id="element-225">
          Sin un sistema claro, siempre terminás igual.
        </p>

        <div className="bg-white rounded-2xl p-5 shadow-sm border border-black/5 mb-6" data-id="element-226">
          <ul className="space-y-3" data-id="element-227">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3" data-id="element-228">
                <X className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-229" />
                <span className="text-[15px] font-medium text-lsa-dark/90" data-id="element-230">
                  {problem}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-lsa-medium text-white p-6 rounded-2xl text-center shadow-lg" data-id="element-231">
          <p className="text-[16px] font-medium leading-relaxed" data-id="element-232">
            No es falta de conocimiento. Es falta de un sistema. Con LSA Fácil
            para Profesores, tus clases están resueltas.{' '}
            <span className="text-xl align-middle ml-1" data-id="element-233">🤟</span>
          </p>
        </motion.div>
      </div>
    </section>;
}